<template>
    <div class="main">
        <c-panel title="TRANSFERÊNCIA DE ESTOQUE" titleIcon="fas fa-exchange-alt">
            <el-alert v-if="!ehSmed" type="error" :closable="false" class="u-mb-15"
                title="Somente a Secretaria de Educação pode transferir estoque."></el-alert>

            <el-form v-else label-position="top" :model="form" ref="form" @submit.native.prevent>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12" :md="8">
                        <el-form-item label="Origem" prop="instituicao_id" :rules="[$requiredChange]">
                            <el-select v-model="form.instituicao_id" filterable placeholder="De onde sai"
                                style="width:100%;" @change="limparProduto">
                                <el-option v-for="i in listaInstituicoes" :key="i.id" :label="i.nome" :value="i.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="8">
                        <el-form-item label="Destino" prop="instituicao_destino_id" :rules="[$requiredChange]">
                            <el-select v-model="form.instituicao_destino_id" filterable placeholder="Para onde vai"
                                style="width:100%;">
                                <el-option v-for="i in destinos" :key="i.id" :label="i.nome" :value="i.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="4">
                        <el-form-item label="Data">
                            <el-date-picker v-model="form.data_movimento" type="date" format="dd/MM/yyyy"
                                value-format="yyyy-MM-dd" style="width:100%;"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="4">
                        <el-form-item label="Documento">
                            <el-input v-model="form.documento" maxlength="60"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8" :md="5">
                        <el-form-item label="Grupo">
                            <el-select v-model="grupoId" filterable clearable placeholder="Todos" style="width:100%;"
                                @change="trocarGrupo">
                                <el-option label="Todos" value=""></el-option>
                                <el-option v-for="g in grupos" :key="g.id" :label="g.nome" :value="g.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="16" :md="11">
                        <el-form-item label="Produto" prop="produto_id" :rules="[$requiredChange]">
                            <el-select v-model="form.produto_id" filterable remote clearable :remote-method="buscarProduto"
                                :loading="buscando" placeholder="Digite o nome ou o código" style="width:100%;"
                                @change="selecionarProduto">
                                <el-option v-for="p in produtos" :key="p.id" :label="rotuloProduto(p)" :value="p.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="8" :sm="5" :md="3">
                        <el-form-item label="Saldo na origem">
                            <el-input :value="produto ? formataQtd(produto.saldo) : ''" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="10" :sm="6" :md="3">
                        <el-form-item label="Quantidade">
                            <el-input v-model="form.quantidade" @keyup.enter.native="salvar" placeholder="0"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="6" :sm="5" :md="2">
                        <el-form-item>
                            <el-button class="u-mt-20" type="primary" icon="el-icon-check" @click="salvar" style="width:100%;">TRANSFERIR</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </c-panel>

        <c-panel v-if="ehSmed" title="ÚLTIMAS TRANSFERÊNCIAS" titleIcon="fas fa-history">
            <div class="container-table" v-loading="carregando">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width:100px;">Data</th>
                            <th>Produto</th>
                            <th>Origem</th>
                            <th>Destino</th>
                            <th style="width:130px;">Documento</th>
                            <th style="width:110px;" class="u-text-center">Quantidade</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="m in movimentos" :key="m.id">
                            <td>{{ formataData(m.data_movimento) }}</td>
                            <td>{{ m.produto ? m.produto.nome : '—' }}</td>
                            <td>{{ m.instituicao ? m.instituicao.nome : '—' }}</td>
                            <td>{{ m.destino ? m.destino.nome : '—' }}</td>
                            <td>{{ m.documento || '—' }}</td>
                            <td class="u-text-center">{{ formataQtd(m.quantidade) }}</td>
                        </tr>
                        <tr v-if="!movimentos.length">
                            <td colspan="6" class="u-text-center" style="color:#909399; padding:12px;">Nenhuma transferência registrada.</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </c-panel>
    </div>
</template>

<script>
/**
 * Transferência de estoque entre instituições — inclusive a devolução de uma
 * escola para o almoxarifado. Uso exclusivo da Secretaria de Educação.
 *
 * A transferência que nasce do atendimento de uma requisição não passa por aqui:
 * ela é gerada pelo próprio atendimento.
 */
export default {
    data: () => ({
        carregando: false,
        buscando: false,
        grupos: [],
        produtos: [],
        produto: null,
        grupoId: '',
        movimentos: [],
        form: {
            instituicao_id: '', instituicao_destino_id: '', produto_id: null,
            quantidade: '', data_movimento: '', documento: ''
        }
    }),
    computed: {
        ehSmed () { return [4, 5, 6, 7, 8, 10].includes(Number(this.$store.state.user.tipo)) },
        /** A store guarda as instituições como objeto; filtrar exige normalizar. */
        listaInstituicoes () {
            const v = this.$store.state.instituicoes
            return Array.isArray(v) ? v : Object.values(v || {})
        },
        /** Origem e destino não podem ser a mesma instituição. */
        destinos () {
            return this.listaInstituicoes.filter(i => i.id !== this.form.instituicao_id)
        }
    },
    mounted () {
        this.form.data_movimento = this.$moment().format('YYYY-MM-DD')
        if (!this.ehSmed) return
        this.carregarGrupos()
        this.carregarMovimentos()
    },
    methods: {
        baseUrl () { return this.$store.state.config.baseUrlApi },
        auth () { return this.$store.getters.getHeaderAuth },
        aviso (msg) { window.eventBus.$emit('alert', { msg, type: 'warning' }) },
        formataQtd (v) { const n = Number(v) || 0; return n % 1 === 0 ? String(n) : n.toFixed(3) },
        /** No select o que importa é quanto existe: "Produto um - (20 un)". */
        rotuloProduto (p) {
            const unidade = String(p.unidade_medida || 'UN').toLowerCase()
            return `${p.nome} - (${this.formataQtd(p.saldo)} ${unidade})`
        },
        formataData (d) { return d ? this.$moment(d).format('DD/MM/YYYY') : '—' },

        carregarGrupos () {
            this.$axios.get(`${this.baseUrl()}/api/almox-grupo/getAll?situacao=true`, this.auth())
                .then(r => { this.grupos = r.data || [] }).catch(e => this.$store.commit('throwException', e))
        },
        carregarMovimentos () {
            this.carregando = true
            this.$axios.post(`${this.baseUrl()}/api/almox-estoque/movimentos`, { tipo: 3 }, this.auth())
                .then(r => { this.movimentos = (r.data && r.data.data) || []; this.carregando = false })
                .catch(e => { this.carregando = false; this.$store.commit('throwException', e) })
        },
        buscarProduto (termo) {
            const busca = (termo || '').trim()
            if (!this.grupoId && busca.length < 2) { this.produtos = []; return }

            this.buscando = true
            this.$axios.post(`${this.baseUrl()}/api/almox-produto/buscar`,
                { grupo_id: this.grupoId || null, busca, instituicao_id: this.form.instituicao_id, limite: 30 }, this.auth())
                .then(r => { this.produtos = r.data || []; this.buscando = false })
                .catch(e => { this.buscando = false; this.$store.commit('throwException', e) })
        },
        trocarGrupo () { this.limparProduto(); if (this.grupoId) this.buscarProduto('') },
        selecionarProduto (id) { this.produto = this.produtos.find(p => p.id === id) || null },
        limparProduto () { this.produtos = []; this.produto = null; this.form.produto_id = null },

        salvar () {
            this.$refs.form.validate(valid => {
                if (!valid) { this.aviso('Preencha os campos obrigatórios.'); return }

                const qtd = Number(String(this.form.quantidade).replace(',', '.'))
                if (!(qtd > 0)) { this.aviso('Informe uma quantidade maior que zero.'); return }

                if (this.produto && qtd > Number(this.produto.saldo)) {
                    this.aviso('Quantidade maior que o saldo disponível na origem.')
                    return
                }

                window.eventBus.$emit('loading', true)

                this.$axios.post(`${this.baseUrl()}/api/almox-estoque/transferir`,
                    Object.assign({}, this.form, { quantidade: qtd }), this.auth())
                    .then(r => {
                        window.eventBus.$emit('loading', false)
                        if (r.data && r.data.erro) { this.aviso(r.data.erro); return }

                        window.eventBus.$emit('alert', { msg: 'Transferência realizada com sucesso.', type: 'success' })
                        this.form.quantidade = ''
                        this.limparProduto()
                        this.carregarMovimentos()
                    })
                    .catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            })
        }
    }
}
</script>
